// extracted by css-extract-rspack-plugin
export default {"Box":"table-group-contents-module__Box__rNBVO","disabledFooter":"table-group-contents-module__disabledFooter__wVXwY"};